import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManagedNotAuthenticated from "hooks/useHttpManagedNotAuthenticated";

import { LoginRequest, TokenResponse } from "types/api/user";

function useUserApi() {
    const { post } = useHttpManagedNotAuthenticated();
    const login = React.useCallback((body: LoginRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<TokenResponse> => {
        return post<undefined, undefined, LoginRequest, TokenResponse>({
            url: "/user/login",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    return {
        login
    };
}

export default useUserApi;